import { postData } from '@/plugins/ApiCalls'

export function getVariantAnalytics(formId, variantId, timePeriod) {
  return postData('forms/' + formId + '/variants/' + variantId + '/analytics', { time_period: timePeriod, variant_id: variantId })
}
